module.exports = __webpack_public_path__ + "e5ba2e87b08758aad039155cea63cd1c.svg";